import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useLanguage } from "../../utils/LanguageContext";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import ContactForm from "../ContactForm";
import headerContent  from '../../content/Logo-text.json'
import { HashLink } from "react-router-hash-link";
import content from "../../content/landing-header.json"
import otherContent from "../../content/header.json"

const SoundWaveLogo = () => {
  const uniqueId = Math.random().toString(36).substr(2, 9);

  return (
    <div className="w-10 h-10 bg-gradient-to-r from-[#0B1F3B] to-[#0F172A] rounded-lg flex items-center justify-center relative overflow-hidden shadow-lg">
      <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none">
        <rect x="2" y="11" width="2" height="2" rx="1" fill="currentColor" />
        <rect x="5.5" y="9" width="2" height="6" rx="1" fill="currentColor" />
        <rect x="9" y="7" width="2" height="10" rx="1" fill="currentColor" />
        <rect x="12.5" y="4" width="2" height="16" rx="1" fill="currentColor" />
        <rect x="16" y="8" width="2" height="8" rx="1" fill="currentColor" />
        <rect x="19.5" y="10" width="2" height="4" rx="1" fill="currentColor" />
      </svg>
    </div>
  );
};

const Header = () => {
  // const content = {
  //   es: {
  //     nav: {
  //       services: "Servicios",
  //       bookNow: "Empieza Hoy",
  //       portal: "Portal",
  //       more: "Más",
  //       about: "Sobre Nosotros",
  //       method: "Nuestro Método",
  //       instructors: "Instructores",
  //       testimonials: "Testimonios",
  //       booking: "Reservar Consulta",
  //     },
  //   },
  //   en: {
  //     nav: {
  //       services: "Services",
  //       bookNow: "Start Today",
  //       portal: "Portal",
  //       more: "More",
  //       about: "About Us",
  //       method: "Our Method",
  //       instructors: "Instructors",
  //       testimonials: "Testimonials",
  //       booking: "Book Consultation",
  //     },
  //   },
  // };

  // const otherContent = {
  //   es: {
  //     nav: {
  //       about: "Nosotros",
  //       method: "Método",
  //       instructors: "Instructores",
  //       success: "Éxito",
  //       contact: "Contacto",
  //     },
  //   },
  //   en: {
  //     nav: {
  //       about: "About",
  //       method: "Method",
  //       instructors: "Instructors",
  //       success: "Success",
  //       contact: "Contact",
  //     },
  //   },
  // };
  const headerDiv = useRef(null);
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, setLanguage } = useLanguage();
  const [showMoreDropdown, setShowMoreDropdown] = useState(false);
  const [showMoreMobile, setShowMoreMobile] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);

  useEffect(() => {
  setShowMoreDropdown(false);
  setShowMoreMobile(false);
  setIsMenuOpen(false);
  window.scrollTo(0, 0);
}, [location.pathname]);


useEffect(() => {
  const handleClickOutside = (event) => {
    if (headerDiv.current && !headerDiv.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  const samePageLink = (event) => {
    const testimonial = document.getElementById("testimonial");
    const service = document.getElementById("service");
    if (testimonial && testimonial.contains(event.target) || service && service.contains(event.target) ) {
      setIsMenuOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  document.addEventListener("click", samePageLink);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("click", samePageLink);
  };
}, []);

  const t =
    location.pathname === "/" ? content[language] : otherContent[language];

  const LanguageToggle = () => (
    <div className="flex items-center space-x-2  bg-[#011f4b] rounded-full p-1 w-[100px] sm:w-[100px]">
      <button
        onClick={() => setLanguage("es")}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === "es"
            ? "bg-gradient-to-r from-[#4A7CFF] to-[#3B82F6] text-white shadow-lg"
            : "text-white hover:text-white"
        }`}
      >
        ES
      </button>
      <button
        onClick={() => setLanguage("en")}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === "en"
            ? "bg-gradient-to-r from-[#4A7CFF] to-[#3B82F6] text-white shadow-lg"
            : "text-white hover:text-white"
        }`}
      >
        EN
      </button>
    </div>
  );

  return (
    <>
      {location.pathname === "/app" ||
      location.pathname === "/privacy-policy" ||
      location.pathname === "/terms-of-service" ||
      location.pathname === "/teacher" ||
      location.pathname === "/booking" ? null : (
        <>
          {location.pathname === "/" ? (
            <>
              <motion.header
                ref={headerDiv}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg "
              >
                <div className="max-w-7xl mx-auto px-4 sm:px-4 md:px-4 lg:px-8 text-center">
                  <div
                    className={`flex justify-between items-center h-20 ${
                      isMenuOpen === true ? " border-b" : ""
                    }`}
                  >
                    {/* Logo */}
                    <HashLink smooth to="/#top" className="flex items-center space-x-2">
                      <SoundWaveLogo />
                      <span className="text-2xl font-heading font-bold text-gray-800 tracking-heading leading-head">
                        {headerContent.logoText}
                      </span>
                    </HashLink>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex items-center space-x-2 sm:space-x-2 text-sm lg:space-x-6 lg:text-base">
                      <a
                        href="#services"
                        className="text-gray-800 hover:text-[#4A7CFF] font-semibold transition-colors whitespace-nowrap font-body"
                      >
                        {t.nav.services}
                      </a>

                      <Link
                        to={"/app"}
                        className="bg-gradient-to-r from-[#4A7CFF] to-[#3B82F6] text-white px-4 sm:px-2 md:px-2 py-2 rounded font-semibold hover:from-[#011f4b] hover:to-[#011f4b] hover:shadow-lg hover:scale-105 transition-all text-sm whitespace-nowrap flex items-center justify-center font-body"
                      >
                        {t.nav.bookNow}
                      </Link>

                      <Link
                        to={"/app"}
                        className="text-gray-800 font-semibold hover:text-[#4A7CFF] transition-colors whitespace-nowrap font-body"
                      >
                        {t.nav.portal}
                      </Link>

                      {/* More Dropdown */}
                      <div className="relative more-dropdown">
                        <button
                          onClick={() => setShowMoreDropdown(!showMoreDropdown)}
                          className="text-gray-800 font-semibold hover:text-[#4A7CFF] transition-colors whitespace-nowrap flex items-center space-x-1 font-body"
                        >
                          <span>{t.nav.more}</span>
                          <svg
                            className={`w-4 h-4 transition-transform ${
                              showMoreDropdown ? "rotate-180" : ""
                            }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="m19 9-7 7-7-7"
                            />
                          </svg>
                        </button>

                        {showMoreDropdown && (
                          <div
                            className="absolute top-full left-0 mt-2 w-48 bg-white/95 backdrop-blur-md rounded-xl shadow-xl border border-white/20 py-2 z-50 text-left"
                            onMouseLeave={() => setShowMoreDropdown(false)}
                          >
                            <Link
                              to={"/about"}
                              className="block px-4 py-2 text-gray-800 font-semibold hover:bg-[#4A7CFF] hover:text-white transition-colors font-body"
                            >
                              {t.nav.about}
                            </Link>
                            <Link
                              to={"/method"}
                              className="block px-4 py-2 text-gray-800 font-semibold hover:bg-[#4A7CFF] hover:text-white transition-colors font-body"
                            >
                              {t.nav.method}
                            </Link>
                            <Link
                              to={"/instructors"}
                              className="block px-4 py-2 text-gray-800 font-semibold hover:bg-[#4A7CFF] hover:text-white transition-colors font-body"
                            >
                              {t.nav.instructors}
                            </Link>
                            <a
                              href="#testimonials"
                              className="block px-4 py-2 text-gray-800 font-semibold hover:bg-[#4A7CFF] hover:text-white transition-colors font-body"
                            >
                              {t.nav.testimonials}
                            </a>
                          </div>
                        )}
                      </div>
                      <LanguageToggle />
                      <button
                        onClick={() => setShowContactForm(true)}
                        className=" bg-[#011f4b] btn-secondary border-2 border-transparent text-white px-4 py-2 rounded-full font-semibold hover:bg-[#4A7CFF] transition-all text-sm flex items-center justify-center font-body"
                      >
                        {t.nav.booking}
                      </button>
                    </nav>

                    {/* Mobile menu button */}
                    <button
                      className="md:hidden"
                      onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                      {isMenuOpen ? (
                        <X className="w-6 h-6" />
                      ) : (
                        <Menu className="w-6 h-6" />
                      )}
                    </button>
                  </div>

                  {/* Mobile menu */}
                  {isMenuOpen && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      className="md:hidden bg-white rounded-b-xl mt-2 p-4"
                    >
                      <nav className="flex flex-col space-y-4 text-left">
                        <a
                          id="service"
                          href="#services"
                          className="text-gray-800 hover:text-[#1AA06A] transition-colors font-body"
                        >
                          {t.nav.services}
                        </a>

                        <Link
                          to={"/app"}
                          className="w-44 bg-gradient-to-r from-[#4A7CFF] to-[#3B82F6] text-white px-6 py-2 rounded font-semibold hover:shadow-lg hover:scale-105 transition-all text-center flex items-center justify-center font-body text-sm"
                        >
                          {t.nav.bookNow}
                        </Link>

                        <Link
                          to={"/app"}
                          className="text-gray-800 hover:text-[#1AA06A] transition-colors font-body"
                        >
                          {t.nav.portal}
                        </Link>

                        {/* More Section - Mobile */}
                        <div>
                          <button
                            onClick={() => setShowMoreMobile(!showMoreMobile)}
                            className="text-gray-800 hover:text-[#4A7CFF] transition-colors flex items-center space-x-2 w-full text-left font-body"
                          >
                            <span>{t.nav.more}</span>
                            <svg
                              className={`w-4 h-4 text-gray-800 transition-transform ${
                                showMoreMobile ? "rotate-180" : ""
                              }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="m19 9-7 7-7-7"
                              />
                            </svg>
                          </button>

                          {showMoreMobile && (
                            <div className="ml-4 mt-2 space-y-2">
                              <a
                                href="/about"
                                className="block text-gray-800 hover:text-[#1AA06A] transition-colors py-1 font-body"
                              >
                                {t.nav.about}
                              </a>
                              <a
                                href="/method"
                                className="block text-gray-800 hover:text-[#1AA06A] transition-colors py-1 font-body"
                              >
                                {t.nav.method}
                              </a>
                              <a
                                href="/instructors"
                                className="block text-gray-800 hover:text-[#1AA06A] transition-colors py-1 font-body"
                              >
                                {t.nav.instructors}
                              </a>
                              <a
                                href="#testimonials"
                                id="testimonial"
                                className="block text-gray-800 hover:text-[#1AA06A] transition-colors py-1 font-body"
                              >
                                {t.nav.testimonials}
                              </a>
                            </div>
                          )}
                        </div>

                        <LanguageToggle />

                        <button
                          onClick={() => setShowContactForm(true)}
                          className="w-44 bg-[#011f4b] btn-secondary border-2 border-transparent text-white px-4 py-2 rounded font-semibold hover:bg-[#1AA06A] transition-all text-sm flex items-center justify-center font-body"
                        >
                          {t.nav.booking}
                        </button>
                      </nav>
                    </motion.div>
                  )}
                </div>
              </motion.header>
              {showContactForm && (
                <ContactForm
                  onClose={() => setShowContactForm(false)}
                  language={language}
                />
              )}
            </>
          ) : (
            <motion.header
             ref={headerDiv}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg"
            >
              <div className="max-w-7xl mx-auto px-4 sm:px-4 md:px-4 lg:px-8">
                <div
                  className={`flex justify-between items-center h-20 ${
                    isMenuOpen === true ? " border-b" : ""
                  }`}
                >
                  {/* Logo */}
                  <Link to={"/"} className="flex items-center space-x-2">
                    <SoundWaveLogo />
                    <span className="text-2xl font-heading font-bold text-gray-800 tracking-heading leading-head">
                      {headerContent.logoText}
                    </span>
                  </Link>

                  {/* Desktop Navigation */}
                  <nav className="hidden md:flex items-center space-x-1 sm:space-x-2 md:space-x-3 lg:space-x-6 xl:space-x-6 2xl:space-x-8">
                    <Link
                      to={"/"}
                      className="text-gray-800 hover:text-[#4A7CFF] font-semibold transition-colors whitespace-nowrap font-body"
                    >
                      Home
                    </Link>
                    <Link
                      to={"/about"}
                      className={`text-gray-800 hover:text-[#4A7CFF] font-semibold transition-colors whitespace-nowrap font-body ${
                        location.pathname === "/about"
                          ? " text-lexora-accent"
                          : ""
                      }`}
                    >
                      {t.nav.about}
                    </Link>
                    <Link
                      to={"/method"}
                      className={`text-gray-800 hover:text-[#4A7CFF] font-semibold transition-colors whitespace-nowrap font-body ${
                        location.pathname === "/method"
                          ? " text-lexora-accent"
                          : ""
                      }`}
                    >
                      {t.nav.method}
                    </Link>
                    <Link
                      to={"/instructors"}
                      className={`text-gray-800 hover:text-[#4A7CFF] font-semibold transition-colors whitespace-nowrap font-body ${
                        location.pathname === "/instructors"
                          ? " text-lexora-accent"
                          : ""
                      }`}
                    >
                      {t.nav.instructors}
                    </Link>
                    <Link
                      to={"/success"}
                      className={`text-gray-800 hover:text-[#4A7CFF] font-semibold transition-colors whitespace-nowrap font-body ${
                        location.pathname === "/success"
                          ? " text-lexora-accent"
                          : ""
                      }`}
                    >
                      {t.nav.success}
                    </Link>
                    <LanguageToggle />
                    <Link
                      to={"/app"}
                      className=" bg-[#011f4b] btn-secondary border-2 border-transparent text-white px-4 py-2 rounded-full font-semibold hover:bg-[#4A7CFF] transition-all text-sm flex items-center justify-center font-body"
                    >
                      {language === "es" ? "Empieza Hoy" : "Start Today"}
                    </Link>
                  </nav>

                  {/* Mobile menu button */}
                  <button
                    className="md:hidden "
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                  >
                    {isMenuOpen ? (
                      <X className="w-6 h-6" />
                    ) : (
                      <Menu className="w-6 h-6" />
                    )}
                  </button>
                </div>

                {/* Mobile menu */}
                {isMenuOpen && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    className="md:hidden bg-white rounded-b-xl mt-2 p-4"
                  >
                    <nav className="flex flex-col space-y-4">
                      <Link
                        to={"/"}
                        className="text-gray-800 hover:text-[#4A7CFF] transition-colors"
                      >
                        Home
                      </Link>
                      <Link
                        to={"/about"}
                        className={` text-gray-800 hover:text-[#4A7CFF] font-medium${
                          location.pathname === "/about"
                            ? " text-lexora-accent"
                            : ""
                        }`}
                      >
                        {t.nav.about}
                      </Link>
                      <Link
                        to={"/method"}
                        className={`text-gray-800 hover:text-[#4A7CFF] transition-colors${
                          location.pathname === "/method"
                            ? " text-lexora-accent"
                            : ""
                        }`}
                      >
                        {t.nav.method}
                      </Link>
                      <Link
                        to={"/instructors"}
                        className={`text-gray-800 hover:text-[#4A7CFF] transition-colors${
                          location.pathname === "/instructors"
                            ? " text-lexora-accent"
                            : ""
                        }`}
                      >
                        {t.nav.instructors}
                      </Link>
                      <Link
                        to={"/success"}
                        className={`text-gray-800 hover:text-[#4A7CFF] transition-colors${
                          location.pathname === "/success"
                            ? " text-lexora-accent"
                            : ""
                        }`}
                      >
                        {t.nav.success}
                      </Link>
                      <LanguageToggle />
                      <Link
                        to={"/app"}
                        className="w-44 btn-primary bg-gradient-accent text-white px-6 py-2 rounded font-semibold text-center text-sm"
                      >
                        {language === "es" ? "Empieza Hoy" : "Start Today"}
                      </Link>
                    </nav>
                  </motion.div>
                )}
              </div>
            </motion.header>
          )}
        </>
      )}
    </>
  );
};

export default Header;
